"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentDetailsModalPropTypes = exports.PaymentDetailsModalDefaultPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var PaymentDetailsModalPropTypes = {
  isOpen: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  data: _propTypes.default.shape({
    snapSummaryLabel: _propTypes.default.string,
    snapPrice: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    taxlabel: _propTypes.default.string,
    taxPrice: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    addOnLabel: _propTypes.default.string,
    baggagePrice: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    total: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
    heading: _propTypes.default.string.isRequired,
    totalLabel: _propTypes.default.string.isRequired,
    currency: _propTypes.default.string.isRequired
  }).isRequired,
  theme: _propTypes.default.object
};
exports.PaymentDetailsModalPropTypes = PaymentDetailsModalPropTypes;
var PaymentDetailsModalDefaultPropTypes = {
  theme: {}
};
exports.PaymentDetailsModalDefaultPropTypes = PaymentDetailsModalDefaultPropTypes;